module.exports = __webpack_public_path__ + "static/media/50n.7b154ded.png";